import axios, { AxiosResponse } from "axios"; // Assuming Axios is installed
import {
  list_tournees_annulation_livreur_url,
  list_tournees_annuler_vendeur_url,
  list_tournees_entrepot_url,
  list_tournees_expediteur_url,
  list_tournees_hub_url,
  list_tournees_livreur_url,
  list_tournees_vendeur_url,
} from "../constants/urls";
import { store } from "../store/store";
import { defaultHeadersWithToken } from "../constants/constants";
import { ServerResponse_ } from "@/interfaces/Server";
import { ReturnList } from "@/interfaces/Return";

export type Payload = {
  page_number: number;
  page_size: number;
  keyword: number;
  statutId: number;
  vendeur_libelle: string;
  isRTO?: boolean;
};

const buildReturnListRequestData = (payload: Payload) => ({
  page_number: payload.page_number,
  page_size: payload.page_size,
  keyword: payload.keyword ? payload.keyword.toString() : "",
  ...(payload.statutId !== 0 && { statutId: payload.statutId }),
  ...(payload.vendeur_libelle && {
    vendeur_libelle: payload.vendeur_libelle,
  }),
});

export const getSellerReturns = async (payload: Payload) => {
  const accessToken = store.getState().authentication.accessToken;

  try {
    const response: AxiosResponse<ServerResponse_<ReturnList>> = await axios({
      url: list_tournees_vendeur_url,
      headers: defaultHeadersWithToken(accessToken),
      data: buildReturnListRequestData(payload),
      method: "POST",
    });

    return response;
  } catch (error: any) {
    console.error(error.description);
  }
};

export const getWarehouseReturns = async (payload: Payload) => {
  const accessToken = store.getState().authentication.accessToken;

  try {
    const response: AxiosResponse<ServerResponse_<ReturnList>> = await axios({
      url: list_tournees_entrepot_url,
      headers: defaultHeadersWithToken(accessToken),
      data: buildReturnListRequestData(payload),
      method: "POST",
    });

    return response;
  } catch (error: any) {
    console.error(error.description);
  }
};

export const getDeliveryReturns = async (payload: Payload) => {
  const accessToken = store.getState().authentication.accessToken;
  try {
    const response: AxiosResponse<ServerResponse_<ReturnList>> = await axios({
      url: list_tournees_livreur_url,
      headers: defaultHeadersWithToken(accessToken),
      data: buildReturnListRequestData(payload),
      method: "POST",
    });

    return response;
  } catch (error: any) {
    console.error(error.description);
  }
};

export const getDeliveryCanceledReturns = async (payload: Payload) => {
  const accessToken = store.getState().authentication.accessToken;

  try {
    const response: AxiosResponse<ServerResponse_<ReturnList>> = await axios({
      url: list_tournees_annulation_livreur_url,
      headers: defaultHeadersWithToken(accessToken),
      data: buildReturnListRequestData(payload),
      method: "POST",
    });

    return response;
  } catch (error: any) {
    console.error(error.description);
  }
};

export const getHubReturns = async (payload: Payload) => {
  const accessToken = store.getState().authentication.accessToken;

  try {
    const response: AxiosResponse<ServerResponse_<ReturnList>> = await axios({
      url: list_tournees_hub_url,
      headers: defaultHeadersWithToken(accessToken),
      data: buildReturnListRequestData(payload),
      method: "POST",
    });

    return response;
  } catch (error: any) {
    console.error(error.description);
  }
};

export const getReturnsCanceledBySeller = async (payload: Payload) => {
  const accessToken = store.getState().authentication.accessToken;

  try {
    const response: AxiosResponse<ServerResponse_<ReturnList>> = await axios({
      url: list_tournees_annuler_vendeur_url,
      headers: defaultHeadersWithToken(accessToken),
      data: buildReturnListRequestData(payload),
      method: "POST",
    });

    return response;
  } catch (error: any) {
    console.error(error.description);
  }
};

export const getExpeditionReturns = async (payload: Payload) => {
  const accessToken = store.getState().authentication.accessToken;
  try {
    const response: AxiosResponse<ServerResponse_<ReturnList>> = await axios({
      url: list_tournees_expediteur_url,
      headers: defaultHeadersWithToken(accessToken),
      data: {
        ...buildReturnListRequestData(payload),
        ...(payload.isRTO !== undefined && { isRTO: payload.isRTO }),
      },
      method: "POST",
    });

    return response;
  } catch (error: any) {
    console.error(error.description);
  }
};
